export enum DirectionsOrigin {
  'None' = 'None',
  'TownIntersections' = 'TownIntersections',
  'GMaps' = 'GMaps',
}
